// Píldora de promoción. La MISMA pieza en el banner de tienda, la tarjeta del grid, el panel de
// detalle y la cotización, igual que `StockChip` se comparte para que todos digan lo mismo.
import { Tag, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/cn';

const BASE =
    'inline-flex items-center gap-1 rounded-full border border-promo-soft-border bg-promo-soft font-bold leading-[1.35] tabular-nums text-promo';

const SIZE = {
    sm: 'px-1.5 py-0.5 text-[10px]',
    md: 'px-2 py-[3px] text-[11.5px]',
} as const;

export function PromoChip({
    icon: Icon = Tag,
    size = 'sm',
    className,
    children,
}: {
    icon?: LucideIcon;
    size?: keyof typeof SIZE;
    className?: string;
    children: React.ReactNode;
}) {
    return (
        <span className={cn(BASE, SIZE[size], className)}>
            <Icon className={size === 'sm' ? 'size-2.5 flex-none' : 'size-3 flex-none'} aria-hidden />
            {children}
        </span>
    );
}
